import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import styles from "./Navigation.module.css";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showNav, setShowNav] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      // Show nav after scrolling past hero (100vh = full viewport height)
      setShowNav(window.scrollY > window.innerHeight - 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  const navItems = [
    { label: "About", id: "about" },
    { label: "Work", id: "work" },
    { label: "Achievements", id: "achievements" },
    // { label: "Contact", id: "contact" },
  ];

  // Don't render nav if not yet scrolled past hero
  if (!showNav) return null;

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.content}>
        <div className={`${styles.logo} mono`}>L</div>

        <ul className={styles.links}>
          {navItems.map((item) => (
            <li
              key={item.id}
              className={styles.link}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
            </li>
          ))}
        </ul>

        <button
          className={styles.menuButton}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <ul className={styles.mobileLinks}>
          {navItems.map((item) => (
            <li
              key={item.id}
              className={styles.mobileLink}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navigation;
